import { createContext, ReactNode, useContext } from 'react';

interface AuxiliaryPanelContextType {
  setContent: (content: ReactNode, force?: boolean) => void;
  clearContent: (force?: boolean) => void;
}

export const AuxiliaryPanelContext =
  createContext<AuxiliaryPanelContextType | null>(null);
export const useAuxiliaryPanel = () => {
  const context = useContext(AuxiliaryPanelContext);

  if (!context) {
    throw new Error('useAuxiliaryPanel must be used within Argon');
  }

  return context;
};
